import { render, staticRenderFns } from "./AppSidebarLink.vue?vue&type=template&id=6860cb08&scoped=true&lang=pug"
import script from "./AppSidebarLink.vue?vue&type=script&lang=ts"
export * from "./AppSidebarLink.vue?vue&type=script&lang=ts"
import style0 from "./AppSidebarLink.vue?vue&type=style&index=0&id=6860cb08&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6860cb08",
  null
  
)

export default component.exports